import React from "react";

const SvgCart = ({ itemsInCart, ...props }) => (
  <svg
    className="Cart_svg__icon Cart_svg__icon-cart"
    viewBox="0 0 25 20"
    fill="none"
    width="1em"
    height="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m1.076 19 .806-11h16.236l.806 11zM15 6v2H5V6a5 5 0 0 1 10 0ZM7.5 12h5"
      stroke="currentColor"
      strokeWidth={2}
    />
    {itemsInCart && (
      <path
        d="M19.5 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
        fill="#fe5e39"
        stroke="currentColor"
        strokeWidth={2}
      />
    )}
  </svg>
);

export default SvgCart;
